import { createSlice } from "@reduxjs/toolkit";

export const mockOrgDevices = [
  {
    "apRadio": null,
    "capabilities": null,
    "deviceNetwork": null,
    "info": {
      "address": null,
      "cpuStats": null,
      "deviceName": "Unity proxy",
      "id": "f0b4d220-8cf0-11ee-8c99-0242ac120002",
      "deviceTag": null,
      "deviceType": "proxy",
      "firmwareVersion": "1.25",
      "hardwareVersion": "A1",
      "joinedOn": 1763090637,
      "linkStatus": "offline",
      "localIpAddr": "192.168.10.121",
      "macAddress": "F0:B4:D2:20:8C:F0",
      "managedProtocol": "nc",
      "memoryStats": null,
      "modelName": "DAP-X2810",
      "poeBudget": 0,
      "poeConsumption": null,
      "publicIpAddr": null,
      "registrationState": "registered",
      "serialNumber": "",
      "siteId": "746903ce-6ee8-4ad3-ad73-ed665193b396",
      "siteName": "20250930_site_123",
      "syncStatus": "unsynced",
      "timeZone": null,
      "traffic24HrUsage": 0,
      "uptime": null,
      "lastOfflineTime": null,
      "connectivityTimeline": null
    },
    "wireless.network": [
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2",
          "5"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": null,
        "id": "967a7708-9e8b-4d57-8e89-687089dd3224",
        "password": null,
        "security": "ENHANCE_OPEN+OPEN",
        "ssid": "100F",
        "version": 43,
        "vlanId": 4094,
        "wpaMode": null
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "5",
          "6"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": null,
        "id": "d49c78c3-658c-482a-8b52-8ebc823d1139",
        "password": null,
        "security": "OPEN",
        "ssid": "1021",
        "version": 3,
        "vlanId": 2000,
        "wpaMode": null
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": "PSK-TKIP/AES",
        "id": "cb44998b-b6b8-40b7-bf92-f078172e1279",
        "password": "dlink123",
        "security": "WPA/WPA2-PERSONAL",
        "ssid": "test!!!!234",
        "version": 3,
        "vlanId": 1,
        "wpaMode": "WPA/WPA2"
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2",
          "5",
          "6"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": "PSK/SAE-AES",
        "id": "da4a3b0a-6c80-489d-8e24-e14c3fd504bd",
        "password": "aA123456",
        "security": "WPA2/WPA3-PERSONAL",
        "ssid": "ISSID",
        "version": 2,
        "vlanId": 1,
        "wpaMode": "WPA2/WPA3"
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": null,
        "id": "5386e200-5a5c-44b8-8354-ad7966c3279b",
        "password": null,
        "security": "OPEN",
        "ssid": "test",
        "version": 4,
        "vlanId": 1,
        "wpaMode": null
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": null,
        "id": "a889a7dc-5d04-44b4-afa5-a2c7f42e214f",
        "password": null,
        "security": "ENHANCE_OPEN",
        "ssid": "test2",
        "version": 2,
        "vlanId": 1,
        "wpaMode": null
      },
      {
        "applyTo": {
          "targets": [],
          "type": "all"
        },
        "band": [
          "2"
        ],
        "broadcastSSID": true,
        "enable": true,
        "encryption": null,
        "id": "6fe9f2dd-5852-43ec-8909-25eafa13fb3a",
        "password": null,
        "security": "ENHANCE_OPEN+OPEN",
        "ssid": "test3",
        "version": 2,
        "vlanId": 1,
        "wpaMode": null
      }
    ],
    "wireless.radio": [
      {
        "band": "2",
        "chanWidth": "Auto",
        "channel": "1",
        "dfsChannels": true,
        "h2040Coexistence": false,
        "id": "e009d6b2-2397-480d-863d-219f0b8f4852",
        "pscChannels": false,
        "rssiThreshold": 1,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 2,
        "wirelessMode": "Auto"
      },
      {
        "band": "5",
        "chanWidth": "Auto",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "e04d2a18-3cb9-4b7c-8071-39694448f70b",
        "pscChannels": null,
        "rssiThreshold": null,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 1,
        "wirelessMode": "Auto"
      },
      {
        "band": "6",
        "chanWidth": "Auto",
        "channel": "Auto",
        "dfsChannels": null,
        "h2040Coexistence": null,
        "id": "e178f3f3-3f5e-4d2f-8f1f-6e2f5b1c8f6a",
        "pscChannels": null,
        "rssiThreshold": null,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 1,
        "wirelessMode": "Auto"
      }
    ]
  },
];

export const onPremExistedOrgDevicesSlice = createSlice({
  name: "onPremExistedOrgDevices",
  initialState: {
    data: [...mockOrgDevices],
  },
});

export default onPremExistedOrgDevicesSlice.reducer;